import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaUser, FaBell, FaLock } from 'react-icons/fa';

const Settings = () => {
    const [notifications, setNotifications] = useState(true);
    const [emailUpdates, setEmailUpdates] = useState(true);

    return (
        <div>
            <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--color-secondary)', marginBottom: '0.5rem' }}>Settings</h1>
            <p style={{ color: '#666', marginBottom: '2rem' }}>Manage your account preferences</p>

            <div style={{ display: 'grid', gap: '1.5rem', maxWidth: '800px' }}>
                {/* Profile Settings */}
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            background: 'var(--color-teal-light)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FaUser size={20} color="var(--color-primary)" />
                        </div>
                        <h3 style={{ fontWeight: '600', fontSize: '1.1rem' }}>Profile Information</h3>
                    </div>

                    <div style={{ display: 'grid', gap: '1rem' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.9rem' }}>Full Name</label>
                            <input
                                type="text"
                                defaultValue="Family Member"
                                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #ddd' }}
                            />
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.9rem' }}>Email</label>
                            <input
                                type="email"
                                defaultValue="student@synapse.com"
                                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #ddd' }}
                            />
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.9rem' }}>Phone</label>
                            <input
                                type="tel"
                                defaultValue="+971 50 123 4567"
                                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #ddd' }}
                            />
                        </div>
                        <button className="button-primary" style={{ width: 'fit-content', padding: '0.75rem 1.5rem' }}>
                            Save Changes
                        </button>
                    </div>
                </motion.div>

                {/* Notifications */}
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            background: '#FFF9E6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FaBell size={20} color="var(--color-accent)" />
                        </div>
                        <h3 style={{ fontWeight: '600', fontSize: '1.1rem' }}>Notifications</h3>
                    </div>

                    <div style={{ display: 'grid', gap: '1rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', background: '#f8f9fa', borderRadius: '8px' }}>
                            <div>
                                <div style={{ fontWeight: '500', marginBottom: '0.25rem' }}>Push Notifications</div>
                                <div style={{ fontSize: '0.85rem', color: '#666' }}>Receive notifications about upcoming sessions</div>
                            </div>
                            <label style={{ position: 'relative', display: 'inline-block', width: '50px', height: '26px' }}>
                                <input
                                    type="checkbox"
                                    checked={notifications}
                                    onChange={(e) => setNotifications(e.target.checked)}
                                    style={{ opacity: 0, width: 0, height: 0 }}
                                />
                                <span style={{
                                    position: 'absolute',
                                    cursor: 'pointer',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: notifications ? 'var(--color-primary)' : '#ccc',
                                    transition: '0.4s',
                                    borderRadius: '26px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        content: '',
                                        height: '20px',
                                        width: '20px',
                                        left: notifications ? '27px' : '3px',
                                        bottom: '3px',
                                        background: 'white',
                                        transition: '0.4s',
                                        borderRadius: '50%'
                                    }}></span>
                                </span>
                            </label>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', background: '#f8f9fa', borderRadius: '8px' }}>
                            <div>
                                <div style={{ fontWeight: '500', marginBottom: '0.25rem' }}>Email Updates</div>
                                <div style={{ fontSize: '0.85rem', color: '#666' }}>Get weekly progress reports via email</div>
                            </div>
                            <label style={{ position: 'relative', display: 'inline-block', width: '50px', height: '26px' }}>
                                <input
                                    type="checkbox"
                                    checked={emailUpdates}
                                    onChange={(e) => setEmailUpdates(e.target.checked)}
                                    style={{ opacity: 0, width: 0, height: 0 }}
                                />
                                <span style={{
                                    position: 'absolute',
                                    cursor: 'pointer',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: emailUpdates ? 'var(--color-primary)' : '#ccc',
                                    transition: '0.4s',
                                    borderRadius: '26px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        content: '',
                                        height: '20px',
                                        width: '20px',
                                        left: emailUpdates ? '27px' : '3px',
                                        bottom: '3px',
                                        background: 'white',
                                        transition: '0.4s',
                                        borderRadius: '50%'
                                    }}></span>
                                </span>
                            </label>
                        </div>
                    </div>
                </motion.div>

                {/* Security */}
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            background: 'var(--color-teal-light)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FaLock size={20} color="var(--color-primary)" />
                        </div>
                        <h3 style={{ fontWeight: '600', fontSize: '1.1rem' }}>Security</h3>
                    </div>

                    <div style={{ display: 'grid', gap: '1rem' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.9rem' }}>Current Password</label>
                            <input
                                type="password"
                                placeholder="••••••••"
                                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #ddd' }}
                            />
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.9rem' }}>New Password</label>
                            <input
                                type="password"
                                placeholder="••••••••"
                                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #ddd' }}
                            />
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.9rem' }}>Confirm New Password</label>
                            <input
                                type="password"
                                placeholder="••••••••"
                                style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #ddd' }}
                            />
                        </div>
                        <button className="button-primary" style={{ width: 'fit-content', padding: '0.75rem 1.5rem' }}>
                            Update Password
                        </button>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Settings;
